import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { DataService } from 'src/app/services/data.service';
import { MessageService } from 'src/app/services/message.service';

@Component({
  selector: 'app-social-content-request-form',
  templateUrl: './social-content-request-form.component.html',
  styleUrls: ['./social-content-request-form.component.css'],
})
export class SocialContentRequestFormComponent {
  url: string = 'socialContentRequests';
  id!: string;
  form!: FormGroup;

  requestedByTypeOptions = ['human', 'system', 'media_room', 'ads'];
  purposeOptions = [
    'evergreen',
    'promo',
    'trust',
    'geo',
    'industry',
    'service',
    'refresh',
    'campaign_support',
  ];
  verticalOptions = ['courier', 'task_runner'];
  platformOptions = ['instagram', 'facebook', 'youtube', 'tiktok', 'linkedin'];
  riskHintOptions = ['low', 'medium', 'high'];
  sourceTriggerOptions = [
    'manual',
    'media_room_ready',
    'refresh_due',
    'performance_drop',
    'ads_alignment',
  ];
  statusOptions = ['new', 'in_progress', 'fulfilled', 'cancelled'];

  resumenCards = [
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'SEO',
      route: '/marketing',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-arrow-trend-up',
      bgClass: 'bg-white',
      desc: 'ADS',
      route: '/marketing/ads',
    },
    {
      label: '',
      value: '', //0
      icon: 'fa-solid fa-people-line',
      bgClass: 'bg-white',
      desc: 'SOCIAL',
      route: '/marketing/social/strategy',
    },
    {
      label: '',
      value: '', //0
      icon: 'fas fa-globe',
      bgClass: 'bg-white',
      desc: 'GEO',
      route: '',
    },
    
  ];

  constructor(
    private dataService: DataService,
    private fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private messageService: MessageService,
  ) {}

  ngOnInit(): void {
    this.initForm();
    this.route.params.subscribe((params: Params) => {
      this.id = params['id'];
      if (this.id) {
        this.getData();
      }
    });
  }

  initForm(): void {
    this.form = this.fb.group({
      request_id: ['', [Validators.required]],
      requested_by_type: ['manual', [Validators.required]],
      purpose: ['', [Validators.required]],
      vertical: ['', [Validators.required]],
      geo_scope_value: [''],
      service_scope: [''],
      industry_scope: [''],
      requested_platforms: [[]],
      risk_hint: ['low'],
      due_date: [null],
      notes: [''],
      source_trigger: ['manual'],
      status: ['new', [Validators.required]],
      linked_media_room_id: [null],
    });
  }

  isFieldInvalid(field: string) {
    return (
      this.form.get(field)?.invalid &&
      (this.form.get(field)?.dirty || this.form.get(field)?.touched)
    );
  }

  onSubmit(): void {
    if (this.form.invalid) {
      this.messageService.add(
        'Por favor complete los campos obligatorios',
        'secondary',
      );
      return;
    }

    if (this.id) {
      this.updateData();
    } else {
      this.createData();
    }
  }

  getData(): void {
    this.dataService.getData(`${this.url}/${this.id}`).subscribe((response) => {
      //console.log('response', response);
      if (response && response.rst) {
        let item = response.data;
        if (item.due_date) {
          item.due_date = new Date(item.due_date).toISOString().split('T')[0];
        }
        this.form.patchValue(item);
      }
    });
  }

  createData(): void {
    this.dataService
      .postData(`${this.url}/create`, this.form.value)
      .subscribe((response) => {
        console.log('response', response);
        if (response && response._id) {
          //this.messageService.add('Solicitud creada correctamente', 'info');
          this.router.navigateByUrl('marketing/social/contentRequests');
        } else {
          //this.messageService.add('Error al crear la solicitud', 'secondary');
        }
      });
  }

  updateData(): void {
    this.dataService
      .putData(`${this.url}/${this.id}/status`, {
        status: this.form.get('status')?.value,
      })
      .subscribe((response) => {
        console.log('response', response);
        if (response.rst) {
          //this.messageService.add(response.msg, 'info');
          this.router.navigateByUrl('marketing/social/contentRequests');
        } else {
          //this.messageService.add(response.msg, 'secondary');
        }
      });
  }

  togglePlatform(platform: string): void {
    const platforms = this.form.get('requested_platforms')?.value as string[];
    const index = platforms.indexOf(platform);
    if (index > -1) {
      platforms.splice(index, 1);
    } else {
      platforms.push(platform);
    }
    this.form.get('requested_platforms')?.setValue(platforms);
  }

  isPlatformSelected(platform: string): boolean {
    const platforms = this.form.get('requested_platforms')?.value as string[];
    return platforms.includes(platform);
  }
}
